import { Cart } from './types';

/** True when every added merchandise id is present on the post-mutate cart. */
export function cartContainsRequestedMerchandise(
  cart: Pick<Cart, 'lines'> | null | undefined,
  lineItemsToAdd: ReadonlyArray<{ merchandiseId?: string }> | undefined,
): boolean {
  const requested = (lineItemsToAdd ?? [])
    .map((line) => line.merchandiseId)
    .filter((id): id is string => Boolean(id));
  if (requested.length === 0) return true;
  const present = new Set(
    cart?.lines?.edges?.map((edge) => edge.node.merchandise.id) ?? [],
  );
  return requested.every((id) => present.has(id));
}
